import { render } from "./VistaProduccion.vue?vue&type=template&id=25ee02db"
import script from "./VistaProduccion.vue?vue&type=script&lang=js"
export * from "./VistaProduccion.vue?vue&type=script&lang=js"

import "./VistaProduccion.vue?vue&type=style&index=0&id=25ee02db&lang=css"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__